import styled from "styled-components";

export const FormUploadNewStyled = styled.div`
  .box_input_item {
    width: 100%;
    .field_error {
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      color: ${({ theme }) => theme.COLORS.RED_3};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      margin-top: 4px;
    }
  }
`;
